import React from "react";
import { HelmetProvider } from 'react-helmet-async';
import { ChakraProvider } from '@chakra-ui/react';
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';

import AuthLayout from "./layouts/Auth.js";
import MainLayout from "./layouts/Main.js";
import LandingPage from "./views/LandingPage.js";
import { AuthProvider } from './contexts/AuthContext';

import '@fontsource/vazirmatn/400.css';
import '@fontsource/vazirmatn/500.css';
import '@fontsource/vazirmatn/700.css';
import '@fontsource/vazirmatn/800.css';

// Custom Chakra theme
import theme from './theme/theme.js';

// Create a client
const queryClient = new QueryClient();

// Set RTL direction globally
document.documentElement.dir = 'rtl';
document.documentElement.lang = 'fa';

function App() {
  return (
    <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={theme} resetCss={false}>
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/auth/*" element={<AuthLayout />} />
              <Route path="/*" element={<MainLayout />} />
            </Routes>
            <Toaster 
              position="top-left"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                  direction: 'rtl',
                  textAlign: 'right',
                },
              }}
            />
          </Router>
        </AuthProvider>
      </ChakraProvider>
    </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
